import React from 'react'
import { findProducts } from '../../../../data'
import Presenter from '../index'

const perPage = 9

const paginate = (array, page_size, page_number) => {
  // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
  return array.slice((page_number - 1) * page_size, page_number * page_size)
}

class Page extends React.Component {
  static async getInitialProps ({ query }) {
    const products = findProducts(query.categories)

    let pagesLen = parseInt(products.length / perPage)
    if (products.length / perPage > pagesLen) {
      pagesLen += 1
    }

    return {
      page: query.page,
      content: query,
      products: products,
      total: products.length,
      pages: pagesLen
    }
  }

  render () {
    const { content, page, pages, products, total } = this.props

    return (
      <Presenter products={products} content={content} page={page} pages={pages} total={total} />
    )
  }
}

export default Page
